import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import React from 'react';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { setAppQuery } from '@src/public/utils/url';
import { ListStore } from '../store';

const Content = () => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { size, total, cutOff } = listStates;
    const hasMore = cutOff && total > size;
    const isFromHws = window.location.search.includes('from=hms');

    const pid = setAppQuery(
        `${window.location.origin.replace('ishare', 'timeline')}${window.location.pathname}${window.location.search}`,
    );

    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'web',
            pid,
            kind: hasMore ? 'inter_sjx04' : 'inter_sjx05',
            noKindFrom: 1,
            download: hasMore
                ? 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7193710240634415104'
                : 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7193710468267681792',
            downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${hasMore ? 9081 : 9082}`,
        },
        statisticsConfig: {},
    };

    return (
        <div className={styles.container}>
            {hasMore ? (
                <div className={styles.mask} />
            ) : null}
            <WxLaunchHack content={wxLaunchHackData} />
            {
                isFromHws ? null : 
                    <div className={hasMore ? `${styles.btn} ${styles.btnMore}` : `${styles.btn}`}>
                        {hasMore ? '打开新闻客户端，查看完整事件' : '打开新闻客户端，跟踪事件进展'}
                    </div> 
            }
        </div>
    );
};

export default errorBoundary(Content);
